module.exports = __webpack_public_path__ + "static/logo-c45c519d5924faf929a976bdf19a107b.png";